import { _loadAmpli, _webAttribution } from "./analytics";
export const configWebAttribution = (options) => {
    const { ampli, environment: stringEnvironment, configuration, disableSessionReplayTracking = false, sessionReplaySampleRate, } = options;
    // Since existing projects use only one environment, which is usually neither "development" nor "production",
    // we need to map it to either "development" or "production".
    const environment = stringEnvironment === "development" ? "development" : "production";
    return {
        webAttribution: (params) => _webAttribution({ ...options, ...params, environment }),
        loadAmpli: () => _loadAmpli(ampli, stringEnvironment, configuration, disableSessionReplayTracking, sessionReplaySampleRate),
    };
};
